export default __webpack_public_path__ + "static/swatches_b.3d5a5ef02b8ffd142aa1dcd88dd8fc3e.svg";